import type { ConversationThreadResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface FacebookThreadViewProps {
  thread: ConversationThreadResponse;
}

export const FacebookThreadView = memo(function FacebookThreadView({
  thread,
}: FacebookThreadViewProps) {
  return <ChatThreadView channel="facebook" thread={thread} />;
});
